import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services';

@Component({
    selector: 'app-mobile-warning',
    templateUrl: './mobile-warning.component.html',
    styleUrls: ['./mobile-warning.component.scss']
})
export class MobileWarningComponent implements OnInit {
    public animateOut: boolean = true;
    public mobile: boolean = false;
    public aspectFail: boolean = false;
    public debug = false;
    public messages: Array<string> = [
        "Please view this experience in a larger browser.",
        "To view the experience properly, please change your aspect ratio by adjusting the height of your window."
    ];
    public message: any = this.messages[0];

    constructor(
        private commonSvc: CommonService
    ) {
        this.debug = this.commonSvc.debug.value;
    }

    ngOnInit(): void {
        if (this.debug) {
            return;
        }

        this.mobileCheck();
        window.addEventListener('resize', this.mobileCheck.bind(this), false);
    }

    public mobileCheck(): void {
        const winW = window.innerWidth;
        const winH = window.innerHeight;
        const aspect = winW / winH;

        console.log(aspect, aspect < 1.56);
        this.aspectFail = (aspect < 1.56);
        const wFail = (winW <= 850);
        const hFail = (winH <= 490);

        if (wFail || hFail || this.aspectFail) {
            this.message = (this.aspectFail && !hFail && !wFail) ? this.messages[1] : this.messages[0];
            this.commonSvc.setMobileWarningOpen(true);

            if (!this.mobile) {
                this.animateOut = true;

                setTimeout(() => {
                    this.mobile = true;
                    this.animateOut = false;
                }, 350);
            }
        } else {
            this.commonSvc.setMobileWarningOpen(false);
            this.mobile = false;
            this.animateOut = false;
        }
    }
}
